// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-3mwvZ";
var _4 = "inner-w30YQ";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "inner" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "inner": _4 }
